import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders, HttpParams } from '@angular/common/http';

import { Subject } from 'rxjs';
import { Observable, throwError } from 'rxjs';
// import 'rxjs/add/operator/catch';
import { catchError } from 'rxjs/operators';


// services
import { ErrorHandler } from './error-handler.service';

// path globals
import { GET_RESIDENTIAL_LOCATIONS, SUBSCRIPTION_KEY, GET_TEXT_FREE_ADDRESSES } from '../globals';
import { Store } from '@ngrx/store';
import { AppState } from 'app/booking/models/app-state.interface';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LocationResidentialService {

  public residentialLocations$: Subject<any> = new Subject();
  public residentialLocationsItem$: Subject<any> = new Subject();

  constructor (
    private _http: HttpClient,
    private _errorService: ErrorHandler,
    private _appStore:Store<AppState>
  ) {}

  getLocationData(value: string, container?: string, isInternational?: string) {
    const state = this.getState(this._appStore);
    const flightData = state.flightReducer.flightDetails.flightResponse;
    const bookingProduct = state.bookingReducer.bookingDetails.bookingProduct;
    // const format = '?format=json&fuzzy=true';
    // const encodedString = encodeURI(value);

    // const headers = new HttpHeaders();
    // headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    // const headers = new HttpHeaders()
    // .set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);

    // this._http
    //   .get(GET_RESIDENTIAL_LOCATIONS + encodedString + format, {headers:headers})
    //   .subscribe((res:any) => {
    //     this.residentialLocations$.next(res);
    //   },
      // err => {
      //   this.residentialLocations$.next(Observable.throw(err));
      //   this._errorService.handleError(err);
      //   return;
      // });

    const departureCountryCode = flightData.flightStatusDetails[0].departureAirport.airportCountryCode;
    const arrivalCountryCode = flightData.flightStatusDetails[flightData.flightStatusDetails.length - 1].arrivalAirport.airportCountryCode;
    let countryCode = bookingProduct === 'abc' ? departureCountryCode : arrivalCountryCode;
    if (isInternational) {
      countryCode = '';
    }

    // console.log(departureCountryCode);
    let params = new HttpParams();
    params = params.append('Key', 'KU54-HR99-HU89-EG38');
    params = params.append('Text', value);
    params = params.append('Countries', countryCode);
    params = params.append('Language', 'en');
    params = params.append('Container', container ?? '');
    this._http.post<any>(GET_TEXT_FREE_ADDRESSES,
      null,
      {
        params: params
      }).subscribe((res) => {
        const filteredResponse = {Items: res.Items.filter(i => i.Type === 'Address' || i.Type === 'Street' || i.Type === 'Postcode' || i.Type === 'BuildingNumber' || i.Type === 'BuildingName') };
        // console.log(res, filteredResponse)
        this.residentialLocations$.next(filteredResponse);
        // let item = res['Items'];
        // if (item[0].Type === "Address") {
        //   if (item.find(i => i.Type === 'Postcode')) {
        //     const postcodeFound = item.find(i => i.Type === 'Postcode');
        //     item = item.filter(el => el.Type !== 'Postcode');
        //     this.getLocationFromPostCode(value, postcodeFound.Id, departureCountryCode, item)
        //   } else {
        //     this.residentialLocations$.next(res);
        //   }
        // } else {
        //   this.getLocationFromPostCode(value, item[0].Id, departureCountryCode, [])
        // }
      },
        err => {
          this.residentialLocations$.next(err);
          this._errorService.handleError(err);
          return;
        });
  }

  getLocationFromPostCode(text: string, container: string, countryCode: string, addAddresses?:[]) {
    // console.log('call back');

    let params = new HttpParams();
    params = params.append('Key', 'KU54-HR99-HU89-EG38');
    params = params.append('Text', text);
    params = params.append('Countries', countryCode);
    params = params.append('Language', 'en');
    if (container) {
      params = params.append('Container', container);
    }
    this._http.post<any>(GET_TEXT_FREE_ADDRESSES,
      null,
      {
        params: params
      }).subscribe((res) => {
        const response = { ...res, Items: [...addAddresses, ...res['Items']]};
        this.residentialLocations$.next(response);
      },
        err => {
          this.residentialLocations$.next(err);
          this._errorService.handleError(err);
          return;
        });
  }

  setLocationSelection(data: Object) {
    this.residentialLocationsItem$.next(data);
  }

  // get store state
  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1))
      .subscribe(s => state = s);
    return state;
  }

};
